var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('Detail',{attrs:{"order":_vm.order}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }